export default __webpack_public_path__ + "static/media/Lato-LightItalic.d04e35ca.ttf";